module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/LTE2-4a4241525ffa17b0e93a0112535164c7.svg";